<template>
  <div class="news-center">
    <!-- banner区域 -->
    <div class="chat-container">
      <div v-for="(msg, index) in messages" :key="index" :class="['message', msg.sender]">
        <div class="content" v-html="msg.text"></div>
        <div v-if="msg.text.includes('我正在思考...')" class="loading-spinner"></div>
      </div>
      
      <div class="input-area">
        <input v-model="query" @keyup.enter="sendMessage" placeholder="输入内容..." />
        <!-- <button
          class="voice-btn"
          @touchstart.prevent="startVoice"
          @touchend.prevent="stopVoice"
          @mousedown.prevent="startVoice"
          @mouseup.prevent="stopVoice">
          🎤
        </button> -->
        <button @click="sendMessage">发送</button>
      </div>
    </div>

    <!-- <CallMe /> -->
    <!-- <MobileCallme class="mobile-callme"></MobileCallme> -->
  </div>
</template>

<script>
import axios from 'axios';
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
import { fetchLawUrl,fetchVke, fetchSetLog } from '@/api';
import jsrsasign from 'jsrsasign';

export default {
  components: { CallMe, MobileCallme },
  data() {
    return {
      query: '',
      response: '',
      messages: [
        { sender: 'bot', text: '您好，我是一名法规标准知识专家，我可以为您回答和EHS、能源等相关的法规问题…快来体验吧~' }
      ],
      recognition: null,
      isRecording: false,   // 录音状态
      lawUrl: '', // 存储接口返回的法律链接
      JWTtoken: '',
      isChatOpen: false, // 控制输入框显示/隐藏
      message: "", // 存储用户输入
      userIP: '', // 存储用户IP地址
      quesLoading: false, // 发送问题按钮加载状态
      isMobile: false, // 是否是移动端
      noUrlItems: [], // 无法获取链接的标题
    };
  },
  mounted() {
    this.checkIfMobile();
    window.addEventListener('resize', this.checkIfMobile);
    this.getAccessToken();
    this.getUserIP();
    // const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    // if (SpeechRecognition) {
    //   this.recognition = new SpeechRecognition();
    //   this.recognition.lang = 'zh-CN';
    //   this.recognition.interimResults = true;
    //   this.recognition.continuous = true;
    //   this.recognition.maxAlternatives = 5;

    //   this.recognition.onresult = (event) => {
    //     let transcript = '';
    //     for (let i = event.resultIndex; i < event.results.length; ++i) {
    //       transcript += event.results[i][0].transcript;
    //     }
    //     this.query = transcript;
    //     // console.log('识别到语音：' + transcript);
    //   };

    //   this.recognition.onend = () => {
    //     if (this.isRecognizing) {
    //       // console.log('语音识别已结束，重新启动...');
    //       this.recognition.start();  // 自动重启
    //     }
    //   };

    //   this.recognition.onerror = (event) => {
    //     console.error('语音识别错误:', event.error);
    //   };
    // } else {
    //   alert('抱歉，当前浏览器不支持语音识别');
    // }
    this.$el.addEventListener('click', this.aClick);
  },
  beforeDestroy() {
    this.$el.removeEventListener('click', this.aClick);
    window.removeEventListener('resize', this.checkIfMobile);
  },
  methods: {
    checkIfMobile() {
      this.isMobile = window.innerWidth <= 768; // 可以根据实际需求调整宽度阈值
    },
    async sendMessage() {
      if (!this.query.trim()) return;
      this.messages.push({ sender: 'user', text: this.query });
      this.autoScroll();
      const userInput = this.query;
      this.query = '';
      
      const thinkingMessageIndex = this.messages.push({ sender: 'bot', text: `您说的是：“${userInput}”，我正在思考...` }) - 1;
      this.autoScroll();
      try {
        const personalAccessToken = this.JWTtoken; // 替换为你的 Token
        const conId = '7468494287353954338'; // 替换为会话 ID
        const botId = '7464752740926406697'; // 替换为机器人 ID
        const userId = '123'; // 替换为用户 ID

        const url = `https://api.coze.cn/v3/chat?conversation_id=${conId}`;

        const headers = {
          'Authorization': `Bearer ${personalAccessToken}`,
          'Content-Type': 'application/json',
          'Accept': '*/*',
          'Host': 'api.coze.cn',
          'Connection': 'keep-alive',
        };

        const data = {
          bot_id: botId,
          user_id: userId,
          additional_messages: [
          {
            role: "user",
            content: userInput,
          },
        ],
          stream: true,
          auto_save_history: true,
        };

        const response = await fetch(url, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(data),
        });
        
        // if (!response.ok) {
        //   throw new Error(`HTTP error! status: ${response.status}`);
        // }
        // 解析 EventStream
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let fullContent = ''; // 存储完整 `result.content`
        let buffer = ''; // 用于缓存未处理的流数据

        let aiResultData = ''; // 存储 result 内容
        let aiThinkProcessData = ''; // 存储 think_process 内容

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          const chunk = decoder.decode(value, { stream: true });
          buffer += chunk;

          // 逐行解析数据
          const lines = buffer.split("\n");
          buffer = lines.pop(); // 可能是未完成的 JSON，留待下次解析

          for (const line of lines) {
            if (line.startsWith("data:")) {
              try {
                const jsonStr = line.replace("data:", "").trim(); // 获取 JSON 部分
                const jsonData = JSON.parse(jsonStr);

                if (jsonData.content) {
                  // content 是字符串，需要二次解析
                  const contentData = JSON.parse(jsonData.content);
                  
                  if (contentData.result) {
                    aiResultData = contentData.result; // 将 result 赋值给 aiResult
                    // console.log('提取到的 result:', aiResultData);
                  }else{
                    if(contentData.result !== undefined){
                      aiResultData = '超出知识库范畴的问题，无法回答';
                    }
                  }
                  if (contentData.think_process) {
                    aiThinkProcessData = contentData.think_process; // 将 think_process 赋值给 aiThinkProcess
                    // console.log('提取到的 think_process:', aiThinkProcessData);
                  }else{
                    if(contentData.think_process !== undefined){
                      aiThinkProcessData = '这个问题似乎超出了一点通的知识库范围,不过我会继续学习和更新信息，希望下次能为你提供更精准的帮助。';
                    }
                  }
                }
              } catch (error) {
                console.error("解析 event-stream JSON 失败:", error, line);
              }
            }
          }
        }
        const logData = `AI回复：${aiResultData}。AI思考过程：${aiThinkProcessData}`;
        const resSetLog = await this.setLog(userInput, logData, this.userIP); // 获取对应的 URL
        // console.log("最终提取的 aiResultData:", aiResultData);
        // console.log("最终提取的 aiThinkProcessData:", aiThinkProcessData);
        // const result = await response.json();
        let aiResult = '';
        let aiThinkProcess = '';

        aiResultData = aiResultData.replace(/《([^》]*)：([^》]*)》/g, '《$1__COLON__$2》');

        // 在指定标点后换行
        aiResultData = aiResultData.replace(/(：|；|。|！|？)/g, "$1\n")
                                  .split("\n") // 按换行符拆分成数组
                                  .filter(line => line.trim()) // 过滤掉空行
                                  .join("\n"); // 重新拼接为字符串

        // 恢复书名号中的 : 为原始格式
        aiResultData = aiResultData.replace(/__COLON__/g, '：');

        // 处理《xxx》加粗（保留书名号）
        aiResultData = aiResultData.replace(/《(.*?)》/g, '《<strong>$1</strong>》');

        // 处理 **xxx** 加粗（保留 **）
        aiResultData = aiResultData.replace(/\*\*(.*?)\*\*/g, '**<strong style="font-size:22px;">$1</strong>**');


        // 处理 ### xxx 加粗（保留 ###）
        aiResultData = aiResultData.replace(/(^|\n)(###\s*)([^\n]+)/g, '$1$2<strong style="font-size:22px;">$3</strong>');

        // 最终拼接成 HTML 字符串
        aiResult = `<strong class="ai-result" style="color:orange;">AI回复：</strong>${aiResultData.replace(/\n/g, '<br>')}`;



        aiThinkProcess = `<strong  class="ai-think-process" style="color:orange;">AI思考过程：</strong >${JSON.stringify(aiThinkProcessData).replace(/\\n/g, '<br>')}`;
        // 拼接 aiResult 和 aiThinkProcess
        this.response = `${aiResult}<br><br>${aiThinkProcess}` || '超出知识库范畴的问题，无法回答';

        // 提取标题
        const matches = this.response.replace(/<strong>(.*?)<\/strong>/g, '$1').match(/《(.*?)》/g);
        const uniqueTitles = [...new Set(matches)];

        // 追加参考规范和标准
        if (uniqueTitles.length > 0) {
          this.noUrlItems = []; // 无法获取链接的标题
          const referenceList = await Promise.all(uniqueTitles.map(async (item, index) => {
            const vkeList = await this.getVke(item); // 获取微课数据
            this.lawUrl = (vkeList && vkeList.law && vkeList.law.lawAIUrl) ? vkeList.law.lawAIUrl : '';
            const lawNewTitle  = (vkeList && vkeList.law && vkeList.law.lawTitle) ? vkeList.law.lawTitle : '';

            const vkeData = (vkeList && Array.isArray(vkeList.lawVkList)) ? vkeList.lawVkList : [];

            if (this.lawUrl && this.lawUrl !== 'https://www.1clicktong.com') {
              return `${index + 1}. <a href="${this.lawUrl}" class="clickable" target="_blank">${lawNewTitle.replace(/<strong>(.*?)<\/strong>/g, '$1')}</a>`;
            } else {
              this.noUrlItems.push(lawNewTitle.replace(/<strong>(.*?)<\/strong>/g, '$1')); // 记录 item
              return `${index + 1}. ${lawNewTitle.replace(/<strong>(.*?)<\/strong>/g, '$1')}`;
            }
          }));
          const noUrlString = this.noUrlItems.join(', ');
          if(noUrlString !== ''){
            this.sendQues(noUrlString);
          }
          // 组装 "参考规范和标准" 部分
          const referenceSection = `<br><br><strong style="color:orange;">参考规范和标准：</strong><br>${referenceList.join('<br>')}`;


          // 组装 "微课链接" 部分
          let vkeLinksSection = "";
          const vkeSet = new Map(); // 用 Map 去重

          await Promise.all(uniqueTitles.map(async (item) => {
            const vkeList = await this.getVke(item); // 获取微课数据
            const vkeData = (vkeList && Array.isArray(vkeList.lawVkList)) ? vkeList.lawVkList : [];

            vkeData.forEach(vk => {
              const exists = Array.from(vkeSet.values()).some(existingVk => 
                existingVk.lawAiVkId === vk.lawAiVkId || existingVk.lawAiVkTitle === vk.lawAiVkTitle
              );

              if (!exists) {
                vkeSet.set(vk.lawAiVkId, vk);
              }
            });
          }));


          // 处理去重后的微课数据
          const uniqueVkeLinks = Array.from(vkeSet.values()).map((vk, index) => 
            `${index + 1}. <a href="${vk.lawAiVkUrl}" class="clickable" target="_blank" style="margin-bottom: 10px;">${vk.lawAiVkTitle}</a>`
          );

          if (uniqueVkeLinks.length > 0) {
            vkeLinksSection = `<br><br><strong style="color:orange;">微课链接：</strong><br><div>${uniqueVkeLinks.join('<br>')}</div>`;
          }

          // 合并所有内容
          this.response += referenceSection + vkeLinksSection;
        }

        this.$set(this.messages, thinkingMessageIndex, { sender: 'bot', text: this.response });
        this.autoScroll();
        this.$nextTick(() => {
          this.addClickListeners();
        });
        
      } catch (error) {
        console.error('调用 Coze API 失败:', error);
        this.error = 'AI 服务暂时不可用，请稍后再试。';
      } finally {
        this.loading = false; // 加载完成
      }
    },
    async aClick(event) {
      const clickedElement = event.target;
      if (clickedElement.tagName === 'A') {
        // 判断点击的是否是 <a> 标签
        const item = clickedElement.textContent.replace(/[《》]/g, '').trim();; // 获取点击的文本内容
        // console.log('点击的内容:', item);

        // this.$router.push({
        //   path: '/RegulatoryDetails',
        //   query: { content: item }
        // }).catch((v) => {});
      }
    },
    addClickListeners() {
      const links = this.$el.querySelectorAll('.clickable');
      links.forEach(link => {
        link.addEventListener('click', this.aClick);
      });
    },
    autoScroll() {
      this.$nextTick(() => {
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
      });
    },
    // 开始语音识别
    startVoice() {
      if (this.recognition && !this.isRecognizing) {
        this.recognition.start();
        this.isRecognizing = true;
        // console.log('开始语音识别...');
      }
    },
    // 停止语音识别
    stopVoice() {
      if (this.recognition && this.isRecognizing) {
        this.recognition.stop();
        this.isRecognizing = false;
        // console.log('停止语音识别');
      }
    },
    // 调用接口获取法律链接
    async getLawUrl(title) {
      // console.log('title', title);  
      
      try {
        const cleanedTitle = title
          .replace(/[《》]/g, '')  // 去掉《》书名号
          .replace(/\s*-\s*/g, '-') // 去掉 - 前后的空格
          .trim(); // 去除前后空格
        // console.log('cleanedTitle', cleanedTitle);
        
        const lawTitle = cleanedTitle; // 替换为你的 Token
        const flag = 'prod'; // 替换为会话 ID

        const data = {
          lawTitle: lawTitle,
          flag: flag
        };

        const result = await fetchLawUrl(data);
        return result;
        
      } catch (error) {
        console.error(error);
      } finally {
      }
    },
    // 微课堂接口
    async getVke(title) {
      // console.log('title', title);  
      
      try {
        const cleanedTitle = title
          .replace(/[《》]/g, '')  // 去掉《》书名号
          .replace(/\s*-\s*/g, '-') // 去掉 - 前后的空格
          .trim(); // 去除前后空格
        // console.log('cleanedTitle', cleanedTitle);
        
        const lawTitle = cleanedTitle; // 替换为你的 Token
        const flag = 'prod'; // 替换为会话 ID

        const data = {
          lawTitle: lawTitle,
          flag: flag
        };

        const result = await fetchVke(data);
        return result;
        
      } catch (error) {
        console.error(error);
      } finally {
      }
    },
    // 存提问的问题
    async setLog(lawAiQuestion, lawAiAnswer, lawAiIp) {
      try {
        const data = {
          lawAiQuestion: lawAiQuestion,
          lawAiAnswer: lawAiAnswer,
          lawAiIp: lawAiIp,
        };

        const result = await fetchSetLog(data);
        return result;
        
      } catch (error) {
        console.error(error);
      } finally {
      }
    },
    async getAccessToken() {
      const url = "https://api.coze.cn/api/permission/oauth2/token";
      const header = {
        alg: 'RS256',
        typ: 'JWT',
        kid: 'oFwyDjPrnxyNJZBH6kBsQwr2CbksUAwuypsFEplmiTs',
      };

      const payload = {
        iss: '1159731040969',
        aud: 'api.coze.cn',
        iat: Math.floor(Date.now() / 1000), // 当前时间戳
        exp: Math.floor(Date.now() / 1000) + 3600, // 过期时间为1小时后
        jti: Math.random().toString(36).substring(2), // 随机生成jti
      };

      const privateKey = `-----BEGIN PRIVATE KEY-----
    MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQC4HfVazSbRhCYb
    w4ey3QRNzdVfrv3sjTcr2sQBbGzSIrkVeN9UCeS7u5qRh6B+sFZPlrZ1zqUF1VTd
    XmmxlcVtpFW0QA6YjJLGyXuDqev5d8bRy8BuvirdhCwqQz2LCtuGmjIvpx6YK8pz
    NszWFicXmHpkcq18WFiutUYLnLJws6KB+LCfpndlKKHvHVc38OfKJ2Ja4NuKwQro
    zHYkcXcSGHmFlyuQlDOSgaEPOMjuDeOSXSIAK6INyyX3kfeGfthF5NF5TZDeZP1s
    4ekFUXsvHJj3pJbMRrBlE0GIC4QZ2vefefhi/OZItRxqe/xruRxv1fiaIvxJGmpU
    KLB9HstdAgMBAAECggEAB1ARTbD2SL4R8Wpbumvy3tA9GFbP+RRGy7QdstzGmbYN
    Wd/6JtFZx2cVJZCYfE+ureyThKxXe5rUixJT6lzDga5URRuCOObkcYbRJBKcr8Tl
    HbIVC5D8DN5SDr+q8xnUTE1VjvT5Txv2J4tWqW4p0VMaEWFIqLatlwrWJGHt6HH4
    nqJePwDs9nqWVrclOfGqpFFra40lsnRlNevLNznbgxe5Qshi9qVV7kL3Q7n/2QGS
    yzAeQ0NZeVhrrhHsTYSFiYz3hY3MkewLtG63oKvZzLRFbH/1mzwd2sHLGbtzEF8z
    NJ4U5Za2/VdP0DGPV5/IJoSePEME50wRBNFjLm+l9QKBgQD9u0YwOmhNRrXlBHMU
    d5I3NKRK6q+ElgdLCkM0L5oB6MVk9UM2TShc6li3L/aRwYt7X7fyrFyBHX/FHBIP
    GqXhxYwY81Ye2NMmVU2EatIeYXI75jLjoEuukGM5DRFlAf22G4MEc/IDD2MF+MLc
    +U3EetHPWGhaUJX6+ix8xaEuxwKBgQC5w1rJbnh8/I/3G+PM0sWBFVvHMGhKs5wt
    /Oze6v/ni40SJ1OwHxn0yn5ThzYP7rSVj0w74ODbb8OOo61O20sKjqfiRR+oVlnq
    tvXZmXeL9LPkBjHcjqadoGat8s8p1Kql8mGcJDBNI6eJdjXfswWTVG/HNy5GFSO6
    Tdkwr3FguwKBgBY6Cor9AtgKIrL+McqQMunNHbtGVbvKnLbxHjP7G4WhS3Ftnsap
    +agyCzV46SOZjctv9iA3Ax94YxH0RIy4K+HcOUqSPnATVGPeQx0fcmqg5K3km36f
    MyIGmfqMb4KmqwAB5vdD5OZpuaXzRbavzCUzESAVwYZv2sOSmMURVu5PAoGASKxT
    jTBJtOP90ne3w/7FQ72+XQvkES15MUicxoz7NnOS6gI2rFVOi0TY7QadsNf7D/Oy
    qE5OyapMwDXqbEpAbk3nAg921h2KKdgQEGQIr9k4s0F1Kksohcwlv3GZeEz5wdg0
    Nai2uMb1GUMEypI34S6MWEyPLt3AT3d7O5+3ZFcCgYEAg1zePYPjpCbefNLUh5pa
    SdIrbudt4Nz2kVY7qfoEmIRSleK+rGUZV1zO68Bo9eZOdKDJI3Jua0qwAbA8azKZ
    cCAEGqb5uwadTcce3FYSoEQkXiEw3yA2SIkDfAlzo8YBMvlT4TaxH1GHVVzBaC9X
    ZfdMxiejeYaNYgFR2ipg3B0=
    -----END PRIVATE KEY-----`;

      const token = jsrsasign.jws.JWS.sign('RS256', header, payload, privateKey);

      try {
        const response = await axios.post(url, {
          duration_seconds: 86399,
          grant_type: "urn:ietf:params:oauth:grant-type:jwt-bearer",
        }, {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          }
        });
        this.JWTtoken = response.data.access_token;
      } catch (error) {
        console.error("Error:", error);
      }
    },
    toggleChat() {
      this.isChatOpen = !this.isChatOpen;
    },
    async sendQues(res) {
      if(!res){
        if (!this.message.trim()) {
          this.$message.warning("请输入问题再发送");
          return;
        }
        this.quesLoading = true;
        try {
          const data = {
            lawAiFeedback: this.message,
            lawAiIp: this.userIP,
          };

          const result = await fetchSendEmail(data);
          if (result.code == '00000') {
            this.$message.success("问题已发送，我们会尽快回复！");
            this.quesLoading = false;
            this.isChatOpen = false;
          }else{
            this.$message.error("发送失败，请稍后再试！");
            this.quesLoading = false;
            this.isChatOpen = false;
            return;
          } 
          
        } catch (error) {
          console.error(error);
          this.quesLoading = false;
        } finally {
          this.quesLoading = false;
        }

        // 清空输入框
        this.message = "";
        this.isChatOpen = false;
      }else{
        try {
          const data = {
            lawAiFeedback: res,
            lawAiIp: this.userIP,
          };

          const result = await fetchSendEmail(data);
          if (result.code == '00000') {
            // console.log("问题已发送，我们会尽快回复！");
          }else{
            console.error("发送失败，请稍后再试！");
            return;
          } 
          
        } catch (error) {
          console.error(error);
        } finally {
        }
        res= '';
      }
    },
    async getUserIP() {
      try {
        const response = await fetch('https://api.ip.sb/geoip');
        const data = await response.json();
        // console.log(data.ip);
        this.userIP = data.ip;
      } catch (err) {
        console.error('获取IP失败', err);
      }
    },
  }
}
</script>

<style scoped>
.news-center {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
}

.chat-container {
  display: flex;
  flex-direction: column;
  max-width: 60%;
  margin: 120px auto;
  padding-bottom: 80px;
  background-color: #fff;
  border-radius: 10px;
}
.loading-spinner {
  width: 20px;
  height: 20px;
  border: 3px solid #ccc;
  border-top: 3px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-top: 5px;
  margin-left: 10px;
}
/* 针对移动端屏幕尺寸调整 */
@media (max-width: 768px) {
  .loading-spinner {
    width: 25px; /* 增加加载图标的大小 */
    height: 25px;
  }
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.message {
  margin: 10px 20px;
  display: flex;
  width: 100%; /* 让消息占满父容器 */
}

.message.user {
  justify-content: flex-end; /* 默认右对齐 */
}

.message.bot {
  justify-content: flex-start; /* 机器人消息左对齐 */
}

.message .content {
  max-width: 80%;
  padding: 12px 16px;
  border-radius: 20px;
  background-color: #e6f7ff;
  font-size: 20px;
  word-break: break-word;
  line-height: 2;
}

.message.user .content {
  background-color: #d9f7be;
}

.input-area {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%); /* 居中对齐输入框 */
  width: 90%; /* 可以设置为较小的宽度 */
  max-width: 1200px; /* 限制最大宽度 */
  display: flex;
  padding: 10px;
  border-top: 1px solid #ccc;
  background-color: #fff;
}

.input-area input {
  flex: 1;
  padding: 15px;
  border: 1px solid #ccc;
  border-radius: 20px;
  font-size: 16px;
  outline: none;
}

.input-area button {
  margin-left: 10px;
  padding: 15px 25px;
  border: none;
  background-color: #1890ff;
  color: #fff;
  border-radius: 20px;
  cursor: pointer;
  font-size: 16px;
}

@media (max-width: 768px) {
  .chat-container {
    max-width: 98%;
    width: 100%;
    margin: 90px auto;
    border-radius: 0;
  }
  .message .content {
    font-size: 18px;
    max-width: 90%;
    padding: 14px 18px;
  }
  .input-area {
    position: fixed;
    bottom: 0;

    width: 100%; /* 可以设置为较小的宽度 */
    max-width: 1200px; /* 限制最大宽度 */
    display: flex;
    padding: 10px;
    border-top: 1px solid #ccc;
    background-color: #fff;
  }
  .input-area input {
    padding: 16px;
    font-size: 18px;
  }
  .input-area button {
    padding: 16px 15px;
    font-size: 18px;
  }
}
.voice-btn {
  width: 50px;
  border-radius: 50%;
  border: none;
  background-color: #ff9800; /* 橙色 */
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  transition: background-color 0.3s ease, transform 0.1s ease;
}

/* 按下时按钮微缩 */
.voice-btn:active {
  background-color: #e65100;
  transform: scale(0.95);
}

/* ====== 智能客服按钮 ====== */
.chat-button {
  position: fixed;
  bottom: 100px;
  right: 20px;
  width: 50px;
  height: 50px;
  font-size: 24px;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* ====== 聊天输入框样式 ====== */
.chat-box {
  position: fixed;
  bottom: 160px;
  right: 20px;
  width: 300px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1001;
  overflow: hidden;
}

/* ====== 头部样式 ====== */
.chat-header {
  color: white;
  padding: 10px;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* ====== 输入框和按钮样式 ====== */
.chat-footer {
  display: flex;
  flex-direction: column;
  padding: 10px;
  gap: 10px;
}

.chat-footer textarea {
  width: 100%;
  min-height: 80px;
  font-size: 14px;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  resize: vertical;
}

.chat-footer .el-button {
  width: 100%;
  height: 40px;
  font-size: 16px;
}

/* ====== 移动端适配 ====== */
@media screen and (max-width: 768px) {
  .chat-button {
    bottom: 20%;
    right: 15px;
    width: 60px; /* 按钮更大 */
    height: 60px;
    font-size: 24px;
  }

  .chat-box {
    width: 90%;
    bottom: 27%;
    right: 5%;
  }

  .chat-header {
    font-size: 18px; /* 标题字体更大 */
    padding: 12px;
    span{
      font-size: 3.5vw; /* 标题字体更大 */
    }
  }

  .chat-footer {
    gap: 12px;
  }

  .chat-footer textarea {
    min-height: 140px; /* 输入框更大 */
    font-size: 18px; /* 文字更大 */
    padding: 10px;
  }

  .chat-footer .el-button {
    height: 50px;
    font-size: 20px;
  }
  ::v-deep(.chat-footer .el-button span) {
    font-size: 16px;
  }

}
</style>
<style>
/* 全局样式 - 在你的 styles.css 或者 App.vue 中 */
@media (max-width: 768px) {
  .el-message {
    font-size: 18px !important; /* 增加字体大小 */
    padding: 12px 18px !important; /* 增加内边距 */
    border-radius: 8px !important; /* 圆角 */
  }

  .el-message__content {
    font-size: 18px !important;
  }
}

</style>
